import * as S from '../styles';
import { FieldRendererProps } from '../types';

const ParagraphField = ({ field }: FieldRendererProps) => (
  <S.ParagraphElement>{field.label}</S.ParagraphElement>
);

export default ParagraphField;
